import { magasin } from './store.ts'

/**
 * Enregistrement du service worker, et proposition de mise à jour.
 *
 * On ne recharge JAMAIS de force. Une nouvelle version qui s'installe toute
 * seule pendant que quelqu'un coche sa liste au rayon surgelés, c'est au
 * mieux une interruption, au pire des coches perdues. On propose, la
 * personne décide.
 */
export type EtatMaj = { disponible: boolean; appliquer: () => void }

export function enregistrerSw(surMaj: (e: EtatMaj) => void): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return

  void navigator.serviceWorker.register('/sw.js').then((enregistrement) => {
    // Le worker envoie ce message quand Background Sync se déclenche
    // (Android uniquement) : il ne fait que réveiller l'app, toute la
    // logique de synchro reste ici, où elle est testable.
    navigator.serviceWorker.addEventListener('message', (e) => {
      if (e.data === 'synchroniser') void magasin.synchroniser()
    })

    const surveiller = () => {
      const entrant = enregistrement.installing ?? enregistrement.waiting
      if (!entrant) return
      entrant.addEventListener('statechange', () => {
        // `controller` non nul = ce n'est pas la première installation, donc
        // c'est bien une MISE À JOUR et non le premier démarrage.
        if (entrant.state === 'installed' && navigator.serviceWorker.controller) {
          surMaj({
            disponible: true,
            appliquer: () => {
              entrant.postMessage('appliquer-maj')
              // `controllerchange` arrive quand le nouveau worker prend la
              // main : c'est le seul moment sûr pour recharger.
              navigator.serviceWorker.addEventListener('controllerchange', () => location.reload(), {
                once: true,
              })
            },
          })
        }
      })
    }

    surveiller()
    enregistrement.addEventListener('updatefound', surveiller)
  })
}
